var _rect, _circle, _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 200",
    role: "img",
    "aria-label": "React logo badge",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 200,
    rx: 22,
    fill: "#f7fbff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 100,
    r: 12,
    fill: "#00a6d6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#00a6d6",
    strokeWidth: 7
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 96,
    cy: 100,
    rx: 66,
    ry: 26
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96,
    cy: 100,
    rx: 66,
    ry: 26,
    transform: "rotate(60 96 100)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96,
    cy: 100,
    rx: 66,
    ry: 26,
    transform: "rotate(120 96 100)"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 178,
    y: 92,
    fontFamily: "Arial, sans-serif",
    fontSize: 36,
    fontWeight: 800,
    fill: "#0b2f55"
  }, "REACT")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 126,
    fontFamily: "Arial, sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#52657c"
  }, "Mock Exam")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.380d5bcc25d658b6fa1891efae70fd7e.svg";
export { ForwardRef as ReactComponent };